<h2>{{title()}}</h2>
@if (subtitle()) {
  <p>{{subtitle()}}</p>
}
